import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import Previewer from 'components/Previewer';
import Uploader from 'components/Uploader';
import Dragger from 'antd/lib/upload/Dragger';

const toBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
});

const CargaDocumento = ({
  disabled,
  file: _file,
  multiple,
}) => {
  const form = Form.useFormInstance();
  const archivo = Form.useWatch('archivo', form);
  const [_base64, setBase64] = useState();

  useEffect(() => {
    const clear = () => {
      setBase64();
      form.setFieldsValue({ archivo: null });
    };
    clear();
  }, []);

  useEffect(() => {
    const convert = async () => {
      try {
        const _base = await toBase64(archivo.file);
        setBase64(_base);
      } catch (error) {
        setBase64();
      }
    };
    if (archivo?.file instanceof File) {
      convert();
    } else {
      setBase64();
    }
  }, [archivo]);

  if (disabled) {
    if (!_file) return null;

    return (
      <Previewer
        iFrameUrl={_file}
        modal={false}
        visible
      />
    );
  }
  const limitMB = 6;
  const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg'];

  return (
    <>
      {multiple ? (
        <Dragger
          label="Documento"
          name="archivo"
          disabled={disabled}
          rules={[{ required: true }]}
          allowedExtensions={allowedExtensions}
          style={{ height: '45vh', display: archivo ? 'none' : null }}
          limitMB={limitMB}
          multiple={multiple}
        />
      ) : (
        <Uploader
          title="Documento"
          formItemName="archivo"
          disabled={disabled}
          rules={[{ required: true }]}
          allowedExtensions={allowedExtensions}
          style={{ height: '45vh', display: archivo ? 'none' : null }}
          limitMB={limitMB}
        />
      )}
      <Previewer
        base64={_base64}
        modal={false}
        visible
      />
    </>
  );
};

CargaDocumento.propTypes = {
  disabled: PropTypes.bool,
  file: PropTypes.string,
  multiple: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
};

CargaDocumento.defaultProps = {
  disabled: false,
  file: null,
  multiple: false,
};

export default CargaDocumento;
